var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilledStar = function SvgFilledStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C3C6D4",
    fillRule: "evenodd",
    d: "m7 10.043-4.114 2.62 1.22-4.723L.343 4.837l4.868-.3L7 0l1.789 4.538 4.868.299L9.894 7.94l1.22 4.723z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2436_172234",
    width: 14,
    height: 13,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C3C6D4",
    fillRule: "evenodd",
    d: "m7 10.043-4.114 2.62 1.22-4.723L.343 4.837l4.868-.3L7 0l1.789 4.538 4.868.299L9.894 7.94l1.22 4.723z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2436_172234)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCB00",
    d: "m-.026-1.986 14.209-.043.05 17-14.208.043z"
  }))));
};
export default SvgFilledStar;